import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LatestArticles from './components/LatestArticles';
import CategorySection from './components/CategorySection';
import TrendingSection from './components/TrendingSection';
import NewsletterSection from './components/NewsletterSection';
import { testimonials } from '@/mocks/articles';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <LatestArticles />
        <CategorySection />
        <TrendingSection />

        <section className="py-12 md:py-16 bg-background-100/60">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                读者评价
              </h2>
              <p className="text-sm text-foreground-500 mt-2">来自真实读者的反馈</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {testimonials.map((t) => (
                <div
                  key={t.id}
                  className="bg-background-50 rounded-lg p-6 border border-background-200/70"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-400">{t.role}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
                  <div className="flex gap-1 mt-3 text-accent-500">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <NewsletterSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '911黑料',
            url: 'https://yrkcpte.cn/',
            description: '探索「911黑料」背后的深度内容，汇聚最全面、最真实的黑料资讯与独家爆料。',
            inLanguage: 'zh-CN',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://yrkcpte.cn/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '911黑料',
            url: 'https://yrkcpte.cn/',
            description: '汇聚最全面、最真实的黑料资讯与独家爆料。',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'tips@yrkcpte.cn',
              contactType: 'tips',
            },
          }),
        }}
      />
    </>
  );
}